import React from 'react'
import Problems from '../../../Encounter/Components/EncounterLeftPortion/Components/Tabs/Summary/Components/Problems/Problems'
import PatientRiskScore from '../../../Encounter/Components/EncounterLeftPortion/Components/Tabs/Summary/Components/Patient Risk Score/PatientRiskScore';
import Allergies from '../../../Encounter/Components/EncounterLeftPortion/Components/Tabs/Summary/Components/Allergies/Allergies';
import HealthConcern from '../../../Encounter/Components/EncounterLeftPortion/Components/Tabs/Summary/Components/Health Concern/HealthConcern';
import ImplantableDevices from '../../../Encounter/Components/EncounterLeftPortion/Components/Tabs/Summary/Components/Implantable Devices/ImplantableDevices';
import AdvanceDirectives from '../../../Encounter/Components/EncounterLeftPortion/Components/Tabs/Summary/Components/Advance Directives/AdvanceDirectives';
import Goals from '../../../Encounter/Components/EncounterLeftPortion/Components/Tabs/Summary/Components/Goals/Goals';
import { FindFirstChild } from '../../../../../../utils/FindMenuOption';

const Summary = ({ expandAll, data, setIsRecordSaved, patientID }) => {

    //================== Clinical Summary ===================//

    let SUMMARY_DATA = {
        "PatientProblemList": [],
        "PatientRiskScore": [],
        "PatientAllergy": [],
        "PatientHealthConcern": [],
        "PatientImplantableDevice": [],
        "PatientAdvanceDirectives": [],
        "PatientGoal": [],
        "PatientAppointment": []
    }
    let { PatientData, ...summaryData } = data || {};
    summaryData = { ...SUMMARY_DATA, ...summaryData };

    let isViewAllowed = FindFirstChild('Patient', 'Encounter')?.ISView ?? true;
    let IsEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd ?? true;
    let IsDeleteAllowed = FindFirstChild('Patient', 'Encounter')?.IsDeleted ?? true;
    console.log("IsEditAllowedIsEditAllowed", IsEditAllowed)
    return (<>
        <div className="C_Head p-1">
            <p className=" heading">SUMMARY</p>
        </div>
        <div className="ar_encounter_main_screen">
            <div className="encounter_summary">
                <div className="encounter_summary-content  hover-scrollbar">
                    <div className="encounters-tabs d-flex flex-column gap-2">
                        <Problems expandAll={expandAll} data={summaryData.PatientProblemList} setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed} />
                        <PatientRiskScore expandAll={expandAll} data={summaryData.PatientRiskScore} setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed} />
                        <Allergies expandAll={expandAll} data={summaryData.PatientAllergy} setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed} />
                        <HealthConcern expandAll={expandAll} data={summaryData.PatientHealthConcern} setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed} />
                        <ImplantableDevices expandAll={expandAll} data={summaryData.PatientImplantableDevice} setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed} />
                        <AdvanceDirectives expandAll={expandAll} data={summaryData.PatientAdvanceDirectives} setIsRecordSaved={setIsRecordSaved} patientID={patientID} IsEditAllowed={IsEditAllowed} isViewAllowed={isViewAllowed} IsDeleteAllowed={IsDeleteAllowed} />
                        <Goals expandAll={expandAll} data={summaryData.PatientGoal} setIsRecordSaved={setIsRecordSaved} patientID={patientID} IsEditAllowed={IsEditAllowed} isViewAllowed={isViewAllowed} IsDeleteAllowed={IsDeleteAllowed} />
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

export default Summary